import { Card, cardActionsClasses, cardContentClasses, styled } from "@mui/material";

export const CardStyled = styled(Card)(({ theme: { spacing } }) => ({
  transition: "0.5s all",
  height: "100%",
  display: "flex",
  border: 0,
  [`& .${cardContentClasses.root}`]: {
    paddingBottom: 0,
    marginBottom: `-${spacing(4)}`,
    width: "100%",
  },
  [`& .${cardActionsClasses.root}`]: {
    padding: spacing(3),
  },
}));
